import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type Parameter = {
    toggle: boolean;
};

export const OpenTradeToggleCheckBox: CustomApiHandler<Parameter, boolean> = props => {
    props.dispatch({
        type: "Custom/OpenTradeAccount/BillingInfoCheckerBox",
        result: props.parameter.toggle,
    });
};

export const chain = [OpenTradeToggleCheckBox];

const toggleCheckBox = createHandlerChainRunner(chain, "BillingInfoCheckerBox");
export default toggleCheckBox;
